import { descargaData } from './mock/descargamock.js';

angular.module('Toke').factory('descargaRepository', function ($q) {

    function getDescarga() {
        return $q.resolve(descargaData);
    }

    // para lista futura
    // function getDescargaFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Descarga')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }

    return {
        getDescarga: getDescarga
    };

});
